import { createPropStyling } from '../privatePropStylingUtils';
export const shadowCssAttrNames = ['boxShadow', 'textShadow'];
export const shadowPropStyling = createPropStyling(shadowCssAttrNames);
//# sourceMappingURL=shadowPropStyling.js.map